module.exports = __webpack_public_path__ + "static/cr-poor-40767d7e3b2cb684986a96a4135f6591.png";